import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function SiteFooter() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="inline-flex w-9 h-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">
                吃瓜<span className="text-primary-600">视频</span>
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              聚合全网热门吃瓜视频合集与精选内容，按事件热度实时整理，让你一次看全最新最热的吃瓜现场。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900 mb-4">视频分类</h4>
            <ul className="space-y-2.5">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/category/${c.id}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900 mb-4">热门入口</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/rank" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  热门排行榜
                </Link>
              </li>
              <li>
                <Link to="/video/v-1003" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  热搜事件盘点
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900 mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                contact@guavideo.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-community-line text-primary-500"></i>
                内容合作 & 投稿
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-500"></i>
                工作日 9:00 - 18:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 国产吃瓜视频. 本网站内容仅供信息分享，请理性观看。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <Link to="/about" className="hover:text-primary-600 transition-colors">
              免责声明
            </Link>
            <Link to="/faq" className="hover:text-primary-600 transition-colors">
              帮助中心
            </Link>
            <span>陕ICP备00000000号</span>
          </div>
        </div>
      </div>
    </footer>
  );
}